import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'instanceOf',
    standalone: false,
})
export class InstanceOfPipe implements PipeTransform {
    transform(value: any, type: any): boolean {
        return value instanceof type;
    }
}
